module.exports = __webpack_public_path__ + "img/horn3.162c6f50.png";